import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form'

import ptBR from 'date-fns/locale/pt-BR';

import "react-datepicker/dist/react-datepicker.css";


const DateComponent = ({
	control,
	disabled=false,
	label=null,
	name,
	required=true,
	value=null,
	...rest
}) => {

	return (
		<>

			<Form.Group className='mb-3'>
				{label && 
					<Form.Label
						className='mb-0'
						htmlFor={name}
					>{label}</Form.Label>
				}

				<Controller 
					control={control}
					id={name}
					name={name}
					value={value}
					rules={{
						required: {
							value: required,
							message: 'Campo obrigatório'
						}
					}}
					render={({ field, fieldState: { error } }) => (
						<>

							<DatePicker
								id={field.name}
								className={`form-control`}
								dateFormat='dd/MM/yyyy'
								// disabled={disabled}
								dropdownMode='select'
								locale={ptBR}
								name={field.name}
								onChange={(date) => field.onChange(date)}
								placeholderText='DD/MM/AAAA'
								showMonthDropdown
								showYearDropdown
								ref={field.ref}
								{...field}
								{...rest}
							/>

							{error && <p className='mt-1 form-error'>{error.message}</p>}

						</>
					)}
				/>
			</Form.Group>

		</>
	)

}

export default DateComponent;
